import { Button } from '@verlo/shared/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from '@verlo/shared/components/ui/dialog';
import { CreditCard, ShieldCheck } from 'lucide-react';

const StatusChangeDialog = ({
  open,
  onOpenChange,
  balance,
  onPayBalance,
  onManagerOverride,
  formatCurrency,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size="form">
        <DialogHeader>
          <DialogTitle>Outstanding Balance</DialogTitle>
          <DialogDescription>
            This table has an unpaid balance of {formatCurrency(balance || 0)}
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <p className="text-sm text-ink-soft">
            Please choose how to proceed:
          </p>
          
          <div className="space-y-2">
            <Button 
              className="w-full h-12 justify-start gap-3 bg-verlo hover:bg-verlo-hover"
              onClick={onPayBalance}
            >
              <CreditCard size={18} />
              <div className="text-left">
                <div className="font-medium">Pay Balance</div>
                <div className="text-xs opacity-80">{formatCurrency(balance || 0)}</div>
              </div>
            </Button>
            
            <Button 
              variant="outline"
              className="w-full h-12 justify-start gap-3 border-ink-faint text-ink-soft hover:bg-surface-2 hover:text-ink"
              onClick={onManagerOverride}
            >
              <ShieldCheck size={18} />
              <div className="text-left">
                <div className="font-medium">Manager Override</div>
                <div className="text-xs text-ink-soft">Requires PIN</div>
              </div>
            </Button>
          </div>
        </div>
        
        <DialogFooter>
          <Button 
            variant="ghost" 
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default StatusChangeDialog;
